(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["locanda-image-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (root.dataset.locandaInit === '1') return;
      root.dataset.locandaInit = '1';

      const slides = root.querySelectorAll('.locanda-carousel__slide');
      const dots = root.querySelectorAll('.locanda-carousel__dot');
      if (slides.length <= 1) return;

      let current = 0;
      let timer = null;

      function show(index) {
        slides.forEach((s, i) => {
          const active = i === index;
          s.classList.toggle('is-active', active);
          if (active) {
            s.removeAttribute('aria-hidden');
          } else {
            s.setAttribute('aria-hidden', 'true');
          }
        });
        dots.forEach((d, i) => {
          const active = i === index;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        current = index;
      }

      function next() {
        show((current + 1) % slides.length);
      }

      // Avvio differito: il timer parte solo dopo window.load (tutte le
      // immagini caricate) E quando il carosello è effettivamente in
      // viewport. Senza questo ritardo, durante il reveal stagger della
      // sezione padre il primo cambio scattava prima che l'utente vedesse
      // la slide iniziale.
      let isVisible = false;
      let isPageLoaded = document.readyState === 'complete';

      function start() {
        if (root.dataset.autoplay !== 'true') return;
        if (!isPageLoaded || !isVisible) return;
        const interval = parseInt(root.dataset.interval, 10) || 4000;
        stop();
        timer = setInterval(next, interval);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.slideTarget, 10);
          show(idx);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      reduceMotion.addEventListener('change', (e) => {
        if (e.matches) stop();
        else start();
      });
      if (reduceMotion.matches) return;

      if (!isPageLoaded) {
        window.addEventListener('load', () => {
          isPageLoaded = true;
          start();
        }, { once: true });
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            isVisible = entry.isIntersecting;
            if (isVisible) start();
            else stop();
          });
        }, { threshold: 0.25 });
        io.observe(root);
      } else {
        isVisible = true;
        if (isPageLoaded) start();
      }
    }

    document.querySelectorAll('[data-locanda-carousel]').forEach(initCarousel);

    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-locanda-carousel]').forEach(initCarousel);
    });
    document.addEventListener('shopify:block:select', (e) => {
      const root = e.target.querySelector('[data-locanda-carousel]') || e.target.closest('[data-locanda-carousel]');
      if (root) initCarousel(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
